import React from 'react'
import { isEmpty, filter, uniqueId } from 'lodash'
import {
  Alert,
  Badge,
  BadgeProps,
  Button,
  Col,
  Modal,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartBar } from '@fortawesome/free-solid-svg-icons'
import ConditionalWrap from 'conditional-wrap'

import { OfferType } from '@monorepo/interfaces'
import { useComponentVisible, Delivery as DeliveryApi } from '@monorepo/hooks'

import { CompletedPercentage } from './CompletedPercentage'
import { IssuesQuality } from './IssuesQuality'
import { TimeStatisticsTable } from './TimeStatisticsTable'

type DeliveryInfoProps = BadgeProps & {
  item: OfferType
  tooltip?: string
}

export const DeliveryInfo: React.FC<DeliveryInfoProps> = ({
  item,
  tooltip,
  ...props
}) => {
  const {
    statistics: { deliveryStatistics, timeTable, timeStatistics },
    loading,
    fetch,
    clear,
  } = DeliveryApi.useDeliveryStatistics()

  const {
    isComponentVisible,
    showComponentHandler,
    hideComponentHandler,
  } = useComponentVisible(false, {
    onShow: fetch.bind(null, item.vendor),
    onHide: clear,
  })

  return item.isStock ? null : (
    <>
      <ConditionalWrap
        condition={tooltip && !isComponentVisible}
        wrap={(children: any) => (
          <OverlayTrigger
            overlay={<Tooltip id={uniqueId('tooltip-')}>{tooltip}</Tooltip>}
          >
            {children}
          </OverlayTrigger>
        )}
      >
        <Badge {...props} onClick={showComponentHandler}>
          <FontAwesomeIcon icon={faChartBar} />
        </Badge>
      </ConditionalWrap>

      <Modal show={isComponentVisible} onHide={hideComponentHandler}>
        <Modal.Header closeButton>
          <Modal.Title>Статистика поставок</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <>
              <Spinner animation="border" variant="primary" /> Загрузка
              данных...
            </>
          ) : (
            <>
              {!deliveryStatistics &&
                isEmpty(timeTable) &&
                isEmpty(filter(timeStatistics, Boolean)) && (
                  <Alert variant="warning">Статистики пока нет</Alert>
                )}
              {deliveryStatistics && (
                <Col xs={12} md={6}>
                  <CompletedPercentage
                    width={200}
                    height={200}
                    deliveryStatistics={deliveryStatistics}
                  />
                </Col>
              )}
              {!isEmpty(timeTable) && (
                <Col xs={12} md={6}>
                  <IssuesQuality
                    width={200}
                    height={200}
                    timeTable={timeTable}
                  />
                </Col>
              )}
              {!isEmpty(filter(timeStatistics, Boolean)) && (
                <Col xs={12} className="margin-top-20">
                  <TimeStatisticsTable timeStatistics={timeStatistics} />
                </Col>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={hideComponentHandler}>
            Закрыть
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
